export const MAX_WIDTH_MD = 780;
export const IS_PROD = __IS_PROD__;
const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
export const BASE_URL = isLocal ? __API_URL__ : `${window.origin}/api`;
export const TRACK_URL = __TRACK_URL__;
export const AXIOS_TIMEOUT = 180 * 1000; // 180 segundos (fue 120s)
export const AXIOS_TIMEOUT_ANALYTICS = 240 * 1000; // 240 segundos para analytics complejos
export const AXIOS_TIMEOUT_REPORT = 1000 * 10 * 60; // 600 segundos (10 minutos)
export const LOCAL_STORAGE_KEY_PREFIX = "opt-";
export const SENTRY_DSN = __SENTRY_DSN__;
export const SENTRY_AUTH_TOKEN = __SENTRY_AUTH_TOKEN__;
export const CHARGEBEE_SITE = __CHARGEBEE_SITE__;
export const CRISP_WEBSITE_ID = __CRISP_WEBSITE_ID__;
export const GOOGLE_CLIENT_ID =
  "290289583628-merl51h3ok8nn0c45j9tpb8ou8cngevb.apps.googleusercontent.com";
